const allowedExternalUrlProtocols = new Set(["https:", "http:", "mailto:"]);

export const isAllowedExternalUrl = (href: string): boolean => {
    if (href.startsWith("#")) return true;

    try {
        return allowedExternalUrlProtocols.has(new URL(href).protocol);
    } catch {
        return false;
    }
};
